export const REVERT_BRAND = 'revert-brand';
const revertBrand = () => ({ type: REVERT_BRAND });
export default revertBrand;
